import React from "react"
import ReactSVG from "react-svg"

const EarnRewardWays = ({ earnedMileageWays }) => {
  return (
    <div className="earn-rewards-container">
      <ReactSVG src={earnedMileageWays.image} className="earn-rewards-image" />
      <p className="earn-rewards-label">{earnedMileageWays.label}</p>
    </div>
  )
}

export default EarnRewardWays
